export default __webpack_public_path__ + "static/media/Flag_of_Solomon_Islands.9707b35b.svg";